import { IProduct } from 'featureSliced/shared/store/reducers/CategoriesReducer/types'

// Same lookup PaymentCC/Credentials.tsx's getProductsToPay uses: top-level products first,
// then each product's innerCategoryItems (sub-template components) — a bucket line can point
// at either. A product the server has already hidden for the chosen pickup date (window
// filter) is absent from both and the lookup returns undefined; callers must treat that as
// "unavailable", not "no restriction".
export const findCatalogProduct = (
  productList: IProduct[],
  productId: number
): IProduct | undefined => {
  const topLevel = productList?.find((product) => product.id === productId)
  if (topLevel) return topLevel
  return productList
    ?.reduce((acc: IProduct[], current) => {
      if (current.innerCategoryItems) {
        return [...acc, ...current.innerCategoryItems]
      }
      return acc
    }, [])
    ?.find((product) => product.id === productId)
}
